// extracted by mini-css-extract-plugin
export var card = "_m2-1";
export var summary = "_m2-0";